var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDomesticH(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 20C4 28.8366 11.1634 36 20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20ZM20 2C10.0589 2 2 10.0589 2 20C2 29.9411 10.0589 38 20 38C29.9411 38 38 29.9411 38 20C38 10.0589 29.9411 2 20 2ZM27.8536 16.9749L29.9749 14.8536C30.1701 14.6583 30.1701 14.3417 29.9749 14.1464C29.7796 13.9512 29.463 13.9512 29.2678 14.1464L27.1464 16.2678C26.9512 16.463 26.9512 16.7796 27.1464 16.9749C27.3417 17.1701 27.6583 17.1701 27.8536 16.9749ZM31.3891 12.7322C30.4128 11.7559 28.8299 11.7559 27.8536 12.7322L25.7322 14.8536C24.7559 15.8299 24.7559 17.4128 25.7322 18.3891C26.7085 19.3654 28.2915 19.3654 29.2678 18.3891L31.3891 16.2678C32.3654 15.2915 32.3654 13.7085 31.3891 12.7322ZM10.8536 14.1464L12.9749 16.2678C13.1701 16.463 13.1701 16.7796 12.9749 16.9749C12.7796 17.1701 12.463 17.1701 12.2678 16.9749L10.1464 14.8536C9.95118 14.6583 9.95118 14.3417 10.1464 14.1464C10.3417 13.9512 10.6583 13.9512 10.8536 14.1464ZM8.73223 16.2678C7.75592 15.2915 7.75592 13.7085 8.73223 12.7322C9.70854 11.7559 11.2915 11.7559 12.2678 12.7322L14.3891 14.8536C15.3654 15.8299 15.3654 17.4128 14.3891 18.3891C13.4128 19.3654 11.8299 19.3654 10.8536 18.3891L8.73223 16.2678Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 26,
    width: 3,
    height: 6,
    rx: 1.5,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomesticH);
export default __webpack_public_path__ + "static/media/DOMESTIC_H.ca3904eda7a4018bf5eadcbc3ecc4352.svg";
export { ForwardRef as ReactComponent };